(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('AdvertisementCtrl', AdvertisementCtrl)
	AdvertisementCtrl.$inject = [
		"$rootScope",
		"$scope",
		"AdvertisementService",
		"SpotService",
		"$controller"];
	function AdvertisementCtrl(
		$rootScope,
		$scope,
		AdvertisementService,
		SpotService,
		$controller
	){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'status','title':'Status'},
			{'class':'col-md-2','field':'class','title':'Class'},
			{'class':'col-md-2','field':'qty','title':'Qty'},
			{'class':'col-md-2','field':'artwork_by','title':'Artwork By'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'invoiced_at','title':'Invoiced At'},
			{'class':'col-md-2','field':'approved_at','title':'Approved At'},
			{'class':'col-md-2','field':'paid_at','title':'Paid At'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-3','field':'status','title':'Advertiser'},
			{'class':'col-md-2','field':'status','title':'Status'},
			{'class':'col-md-3','field':'class','title':'Class'},
			{'class':'col-md-1','field':'qty','title':'Qty'},
			{'class':'col-md-1','field':'artwork_by','title':'Art'},
		];
		ctrl.advertiserAdvertisementColumns = [
			{'class':'col-md-6','field':'status','title':'Issue'},
			{'class':'col-md-2','field':'status','title':'Status'},
			{'class':'col-md-2','field':'class','title':'Class'},
			{'class':'col-md-1','field':'qty','title':'Qty'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.advertisements			= [];
		ctrl.advertisement			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;
		ctrl.summary = {};

		// get all Advertisements
		ctrl.getAdvertisements = function(){
			AdvertisementService.getAllAdvertisements(ctrl.searchDB)
			.then(function(res){
				ctrl.advertisements = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.advertisementCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAdvertisements: ", err);
			});
		}

		// get all Advertisements for a specific parent
		ctrl.getAdvertiserAdvertisementsModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			AdvertisementService.getAllAdvertisementsByParent(parentId,parentType)
			.then(function(res){
				ctrl.advertisements = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAdvertisements: ", err);
			});
		}

		// get all Advertisements for a specific parent
		ctrl.getAdvertisementsModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			AdvertisementService.getAllAdvertisementsByParent(parentId,parentType)
			.then(function(res){
				ctrl.advertisements = res;
				ctrl.getSummary(parentId,parentType);
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAdvertisements: ", err);
			});
		}

		// get all Spots for a specific parent
		ctrl.getSummary = function(parentId,parentType){
			console.log('summary is firing.');
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			AdvertisementService.getAdvertisementSummary(parentId,parentType)
			.then(function(res){
				ctrl.summary = res;
				ctrl.categories = ctrl.summary.categories;
				ctrl.isLoaded = true;
				console.log('SUMMARY',ctrl.summary);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSpots: ", err);
			});
		}

		// get a specific Advertisement
		ctrl.getAdvertisement = function(advertisementId){
			AdvertisementService.getAdvertisement(advertisementId)
			.then(function(res){
				ctrl.advertisement = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAdvertisements: ", err);
			});
		}

		// delete a specific Advertisement
		ctrl.deleteAdvertisement= function (advertisement){
			if(confirm('Are you sure you want to delete this advertisement?')){
				AdvertisementService.deleteAdvertisement(advertisement.uid)
				.then(function(res){
					var position = ctrl.advertisements.map(function(advertisement){
						return advertisement.id;
					}).indexOf(advertisement.id);
					ctrl.advertisements.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Advertisements
		ctrl.searchAdvertisements = function(){
			AdvertisementService.getAllAdvertisements(ctrl.searchDB)
			.then(function(res){
				ctrl.advertisements = res.data;
				ctrl.advertisementCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchAdvertisements: ", err);
			});
		}

		ctrl.formatNumber = function(i) {
			return Math.round(i * 100)/100;
		}

		// Events Listeners
		var createListener = $rootScope.$on('AdvertisementCtrl.create', function (event, data) {
			ctrl.advertisements.push(data.payload);
			ctrl.getSummary(ctrl.parentId,ctrl.parentType);
		});
		var updateListener = $rootScope.$on('AdvertisementCtrl.update', function (event, data) {
			var position = ctrl.advertisements.map(function(advertisement){
				return advertisement.id;
			}).indexOf(data.id);
			ctrl.advertisements[position] = data;
		});
		var deleteListener = $rootScope.$on('AdvertisementCtrl.destroy', function (event, data) {
			var position = ctrl.advertisements.map(function(advertisement){
				return advertisement.id;
			}).indexOf(data.object.id);
			ctrl.advertisements.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('AdvertiserCtrl', AdvertiserCtrl)
	AdvertiserCtrl.$inject = [
		"$rootScope",
		"$scope",
		"AdvertiserService",
		"$controller"
	];
	function AdvertiserCtrl(
		$rootScope,
		$scope,
		AdvertiserService,
		$controller
	){
		var ctrl = this;

		ctrl.global = $rootScope;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-1','field':'status','title':'Status'},
			{'class':'col-md-1','field':'trade','title':'Trade'},
			{'class':'col-md-7','field':'publications','title':'Issues'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-7','field':'name','title':'Name'},
			{'class':'col-md-5','field':'trade','title':'Trade'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.advertisers			= [];
		ctrl.advertiser			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;
		ctrl.filterPhone = false;
		ctrl.filterEmail = false;
		ctrl.filterAddress = false;

		// get all Advertisers
		ctrl.getAdvertisers = function(){
			AdvertiserService.getAllAdvertisers(ctrl.searchDB)
			.then(function(res){
				ctrl.advertisers = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.advertiserCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAdvertisers: ", err);
			});
		}

		// get all Advertisers for a specific parent
		ctrl.getAdvertisersModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			AdvertiserService.getAllAdvertisersByParent(parentId,parentType)
			.then(function(res){
				ctrl.advertisers = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAdvertisers: ", err);
			});
		}

		// get all Advertisers for a specific parent
		ctrl.getOrphanedAdvertisers = function(){
			AdvertiserService.getOrphanedAdvertisers()
			.then(function(res){
				ctrl.orphans = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAdvertisers: ", err);
			});
		}

		// get a specific Advertiser
		ctrl.getAdvertiser = function(advertiserId){
			AdvertiserService.getAdvertiser(advertiserId)
			.then(function(res){
				ctrl.advertiser = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAdvertisers: ", err);
			});
		}

		// delete a specific Advertiser
		ctrl.deleteAdvertiser= function (advertiser){
			if(confirm('Are you sure you want to delete this advertiser?')){
				AdvertiserService.deleteAdvertiser(advertiser.uid)
				.then(function(res){
					var position = ctrl.advertisers.map(function(advertiser){
						return advertiser.id;
					}).indexOf(advertiser.id);
					ctrl.advertisers.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		ctrl.attachAdvertiser = function(advertiser){
			var data = {
				parentId:ctrl.parentId,
				parentType:ctrl.parentType,
				advertiserId:advertiser.id,
			}
			// return;
			AdvertiserService.attachAdvertiserToParent(data)
			.then(function(res){
				ctrl.advertisers.push(res);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM attachAdvertiser: ", err);
			});
		}

		// delete a specific Advertiser
		ctrl.detachAdvertiser = function(advertiser){
			var data = {
				parentId:ctrl.parentId,
				parentType:ctrl.parentType,
				advertiserId:advertiser.id,
			}
			// return;
			AdvertiserService.detachAdvertiserFromParent(data)
			.then(function(res){
				var position = ctrl.advertisers.map(function(publication){
					return publication.id;
				}).indexOf(res.id);
				ctrl.advertisers.splice(position,1);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM detachAdvertiser: ", err);
			});
		}

		// delete a specific Advertiser
		ctrl.detachAdvertiserFromPublication = function(advertiser){
			var data = {
				parentId:ctrl.parentId,
				parentType:ctrl.parentType,
				advertiserId:advertiser.id,
			}
			// return;
			AdvertiserService.detachAdvertiserFromParent(data)
			.then(function(res){
				ctrl.detachAdvertiser(advertiser);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM detachAdvertiser: ", err);
			});
		}

		// Search all Advertisers
		ctrl.searchAdvertisers = function(){
			AdvertiserService.getAllAdvertisers(ctrl.searchDB)
			.then(function(res){
				ctrl.advertisers = res.data;
				ctrl.advertiserCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchAdvertisers: ", err);
			});
		}

		ctrl.emptyOrNullPhone = function(item){
			if(ctrl.filterPhone) {
				return !(item.phone === null)
			}
			return true;
		}

		ctrl.emptyOrNullAddress = function(item){
			if(ctrl.filterAddress) {
				return !(item.address === null)
			}
			return true;
		}

		ctrl.emptyOrNullEmail = function(item){
			if(ctrl.filterEmail) {
				return !(item.email === null)
			}
			return true;
		}

		ctrl.getModelType = function(model){
			return model.split('\\').join('-');
		}

		// Events Listeners
		var createListener = $rootScope.$on('AdvertiserCtrl.create', function (event, data) {
			ctrl.advertisers.push(data.payload);
		});
		var updateListener = $rootScope.$on('AdvertiserCtrl.update', function (event, data) {
			var position = ctrl.advertisers.map(function(advertiser){
				return advertiser.id;
			}).indexOf(data.id);
			ctrl.advertisers[position] = data;
		});
		var updateProspectListener = $rootScope.$on('AdvertiserCtrl.updateProspect', function (event, data) {
			var position = ctrl.advertisers.map(function(advertiser){
				return advertiser.id;
			}).indexOf(data.payload.advertiser_id);
			ctrl.advertisers[position].pivot = data.payload;
		});
		var refreshListener = $rootScope.$on('AdvertiserCtrl.refresh', function (event, data) {
			ctrl.advertiser = data;
		});
		var deleteListener = $rootScope.$on('AdvertiserCtrl.destroy', function (event, data) {
			var position = ctrl.advertisers.map(function(advertiser){
				return advertiser.id;
			}).indexOf(data.object.id);
			ctrl.advertisers.splice(position,1);
		});

		var createPhoneListener = $rootScope.$on('AdvertiserCtrl.createPhone', function (event, data) {
			var phone = data.payload;
			angular.forEach(ctrl.advertisers, function (advertiser, index) {
				if (advertiser.id == phone.phoneable_id) {
					ctrl.advertisers[index].phones.push(phone);
				}
			});
		});
		var createAddressListener = $rootScope.$on('AdvertiserCtrl.createAddress', function (event, data) {
			var address = data;
			angular.forEach(ctrl.advertisers, function (advertiser, index) {
				if (advertiser.id == address.addressable_id) {
					ctrl.advertisers[index].addresses.push(address);
				}
			});
		});
		var createEmailListener = $rootScope.$on('AdvertiserCtrl.createEmail', function (event, data) {
			var email = data.payload;
			angular.forEach(ctrl.advertisers, function (advertiser, index) {
				if (advertiser.id == email.emailable_id) {
					ctrl.advertisers[index].emails.push(email);
				}
			});
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('BulkAttachFormCtrl', BulkAttachFormCtrl)
	BulkAttachFormCtrl.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'AdvertiserService',
		"$controller"
	];
		function BulkAttachFormCtrl(
			$rootScope,
			$scope,
			$uibModalInstance,
			items,
			AdvertiserService,
			$controller
		){

			var ctrl = this;

			//Get the default functionality for modal form
			var base = $controller('BaseFormCtrl', {$scope: $scope});

			angular.extend(this, base);

			if((items != undefined)&&(items.bind != undefined)) {
				ctrl.bind = items.bind;
				ctrl.originalObj = angular.extend({}, items.bind);
			}

			if((items != undefined)&&(items.expect != undefined)) {
				ctrl.expectEvent = items.expect;
			}

			ctrl.selectedAdvertisers	= [];
			ctrl.advertisers			= [];

			// get all Advertisers
			ctrl.getAdvertisers = function(parentId,parentType){
				ctrl.parentId = parentId;
				ctrl.parentType = parentType;
				AdvertiserService.getUnassociatedAdvertisersByParent(parentId,parentType)
				.then(function(res){
					ctrl.advertisers = res;
					ctrl.advertiserCount = res.count;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getAdvertisers: ", err);
				});
			}

			// get all Advertisers for a specific parent
			ctrl.getParentAdvertisers = function(parentId,parentType){
				ctrl.parentId = parentId;
				ctrl.parentType = parentType;
				AdvertiserService.getAllAdvertisersByParent(parentId,parentType)
				.then(function(res){
					ctrl.advertisers = res;
					ctrl.isLoaded = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getAdvertisers: ", err);
				});
			}

			ctrl.bulkAddAdvertiser = function(){
				var data = ctrl.bind;
				data.advertisers = ctrl.selectedAdvertisers;
				AdvertiserService.bulkAttachAdvertiserToParent(data)
				.then(function(res){
					ctrl.advertisers.push(res);
					ctrl.fireEvents(res);
					$uibModalInstance.close(res)
				})
				.catch(function(err){
					if (err.status == 422) {
						ctrl.hasError = true;
						ctrl.errors = ctrl.processErrors(err.data);
					}
					console.error("ERROR RESPONDING FROM addAdvertiser: ", err);
				});
			}

			ctrl.toggleAdvertiser = function(advertiser){
				if (ctrl.selectedAdvertisers.indexOf(advertiser) != -1) return;
				ctrl.selectedAdvertisers.push(advertiser.id);
			}

			ctrl.fireEvents = function (d) {
				if (ctrl.expectEvent != undefined && ctrl.expectEvent != '') {
					$rootScope.$emit(ctrl.expectEvent, d);
				} else {
					//
				}
			}

			$scope.ok = ctrl.bulkAddAdvertiser;

			$scope.cancel = function () {
				if(ctrl.bind != undefined) {
					// angular.extend(ctrl.bind, originalObj);
				}
				$uibModalInstance.dismiss('cancel');
			};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('IssueCtrl', IssueCtrl)
	IssueCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","IssueService","$controller"];
	function IssueCtrl($rootScope,$scope, $http, $filter, $uibModal, IssueService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-3','field':'name','title':'Name'},
			{'class':'col-md-1','field':'status','title':'Status'},
			{'class':'col-md-2','field':'type','title':'Type'},
			{'class':'col-md-3','field':'','title':'Publication'},
			{'class':'col-md-2','field':'','title':'Publisher'},
			// {'class':'col-md-2','field':'spots_available','title':'Spots Available'},
			// {'class':'col-md-2','field':'spots_reserved','title':'Spots Reserved'},
			// {'class':'col-md-2','field':'manager','title':'Manager'},
			// {'class':'col-md-2','field':'description','title':'Description'},
			// {'class':'col-md-2','field':'publish_on','title':'Publish On'},
			// {'class':'col-md-2','field':'draft_link','title':'Draft Link'},
			// {'class':'col-md-2','field':'final_link','title':'Final Link'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'status','title':'Status'},
			{'class':'col-md-2','field':'publish_on','title':'Publish On'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.issues			= [];
		ctrl.issue			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Issues
		ctrl.getIssues = function(){
			IssueService.getAllIssues(ctrl.searchDB)
			.then(function(res){
				ctrl.issues = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.issueCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getIssues: ", err);
			});
		}

		// get all Issues for a specific parent
		ctrl.getIssuesModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			IssueService.getAllIssuesByParent(parentId,parentType)
			.then(function(res){
				ctrl.issues = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getIssues: ", err);
			});
		}

		// get all Issues for a specific parent
		ctrl.getIssuesByStatus = function(parentId,parentType){
			IssueService.getIssuesByScope('Active')
			.then(function(res){
				ctrl.issues = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getIssuesByStatus: ", err);
			});
		}

		// get a specific Issue
		ctrl.getIssue = function(issueId){
			IssueService.getIssue(issueId)
			.then(function(res){
				ctrl.issue = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getIssues: ", err);
			});
		}

		// delete a specific Issue
		ctrl.deleteIssue= function (issue){
			if(confirm('Are you sure you want to delete this issue?')){
				IssueService.deleteIssue(issue.uid)
				.then(function(res){
					var position = ctrl.issues.map(function(issue){
						return issue.id;
					}).indexOf(issue.id);
					ctrl.issues.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Issues
		ctrl.searchIssues = function(){
			IssueService.getAllIssues(ctrl.searchDB)
			.then(function(res){
				ctrl.issues = res.data;
				ctrl.issueCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchIssues: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('IssueCtrl.create', function (event, data) {
			ctrl.issues.push(data.payload);
		});
		var updateListener = $rootScope.$on('IssueCtrl.update', function (event, data) {
			var position = ctrl.issues.map(function(issue){
				return issue.id;
			}).indexOf(data.id);
			ctrl.issues[position] = data;
		});
		var deleteListener = $rootScope.$on('IssueCtrl.destroy', function (event, data) {
			var position = ctrl.issues.map(function(issue){
				return issue.id;
			}).indexOf(data.object.id);
			ctrl.issues.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('ProspectCtrl', ProspectCtrl)
	ProspectCtrl.$inject = [
		"$rootScope",
		"$scope",
		"ProspectService",
		"$controller"
	];
	function ProspectCtrl(
		$rootScope,
		$scope,
		ProspectService,
		$controller
	){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'status','title':'Status'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'status','title':'Status'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.prospects			= [];
		ctrl.prospect			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Prospects
		ctrl.getProspects = function(){
			ProspectService.getAllProspects(ctrl.searchDB)
			.then(function(res){
				ctrl.prospects = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.prospectCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getProspects: ", err);
			});
		}

		// get all Prospects for a specific parent
		ctrl.getParentProspects = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			ProspectService.getAllProspectsByParent(parentId,parentType)
			.then(function(res){
				ctrl.prospects = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getProspects: ", err);
			});
		}

		// get a specific Prospect
		ctrl.getProspect = function(prospectId){
			ProspectService.getProspect(prospectId)
			.then(function(res){
				ctrl.prospect = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getProspects: ", err);
			});
		}

		// delete a specific Prospect
		ctrl.deleteProspect= function (prospect){
			if(confirm('Are you sure you want to delete this prospect?')){
				ProspectService.deleteProspect(prospect.uid)
				.then(function(res){
					var position = ctrl.prospects.map(function(prospect){
						return prospect.id;
					}).indexOf(prospect.id);
					ctrl.prospects.splice(position, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteProspect: ", err);
				});
			}
		}

		// Search all Prospects
		ctrl.searchProspects = function(){
			ProspectService.getAllProspects(ctrl.searchDB)
			.then(function(res){
				ctrl.prospects = res.data;
				ctrl.prospectCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchProspects: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('ProspectCtrl.create', function (event, data) {
			ctrl.prospects.push(data.payload);
		});
		var updateListener = $rootScope.$on('ProspectCtrl.update', function (event, data) {
			var position = ctrl.prospects.map(function(prospect){
				return prospect.id;
			}).indexOf(data.id);
			ctrl.prospects[position] = data;
		});
		var deleteListener = $rootScope.$on('ProspectCtrl.destroy', function (event, data) {
			var position = ctrl.prospects.map(function(prospect){
				return prospect.id;
			}).indexOf(data.object.id);
			ctrl.prospects.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('PublicationCtrl', PublicationCtrl)
	PublicationCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","PublicationService","$controller"];
	function PublicationCtrl($rootScope,$scope, $http, $filter, $uibModal, PublicationService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-4','field':'name','title':'Name'},
			{'class':'col-md-2','field':'publisher','title':'Publisher'},
			{'class':'col-md-5','field':'description','title':'Description'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-6','field':'name','title':'Name'},
			{'class':'col-md-5','field':'publisher','title':'Publisher'},
			// {'class':'col-md-2','field':'description','title':'Description'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.publications			= [];
		ctrl.publication			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Publications
		ctrl.getPublications = function(){
			PublicationService.getAllPublications(ctrl.searchDB)
			.then(function(res){
				ctrl.publications = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.publicationCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPublications: ", err);
			});
		}

		// get all Publications for a specific parent
		ctrl.getPublicationsModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			PublicationService.getAllPublicationsByParent(parentId,parentType)
			.then(function(res){
				ctrl.publications = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPublications: ", err);
			});
		}

		// get a specific Publication
		ctrl.getPublication = function(publicationId){
			PublicationService.getPublication(publicationId)
			.then(function(res){
				ctrl.publication = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPublications: ", err);
			});
		}

		// delete a specific Publication
		ctrl.deletePublication= function (publication){
			if(confirm('Are you sure you want to delete this publication?')){
				PublicationService.deletePublication(publication.uid)
				.then(function(res){
					var position = ctrl.publications.map(function(publication){
						return publication.id;
					}).indexOf(publication.id);
					ctrl.publications.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		ctrl.attachPublication = function(publication){
			var data = {
				parentId:ctrl.parentId,
				parentType:ctrl.parentType,
				publicationId:publication.id,
			}
			console.log('attachPublication DATA:\n',data);
			// return;
			PublicationService.attachPublicationToParent(data)
			.then(function(res){
				ctrl.publications.push(res);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM attachPublication: ", err);
			});
		}

		// delete a specific Publication
		ctrl.detachPublication = function(publication){
			var data = {
				parentId:ctrl.parentId,
				parentType:ctrl.parentType,
				publicationId:publication.id,
			}
			console.log('detachPublication DATA:\n',data);
			// return;
			PublicationService.detachPublicationFromParent(data)
			.then(function(res){
				var position = ctrl.publications.map(function(publication){
					return publication.id;
				}).indexOf(res.id);
				ctrl.publications.splice(position,1);
				})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM detachPublication: ", err);
			});
		}

		// Search all Publications
		ctrl.searchPublications = function(){
			PublicationService.getAllPublications(ctrl.searchDB)
			.then(function(res){
				ctrl.publications = res.data;
				ctrl.publicationCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchPublications: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('PublicationCtrl.create', function (event, data) {
			ctrl.publications.push(data.payload);
		});
		var updateListener = $rootScope.$on('PublicationCtrl.update', function (event, data) {
			var position = ctrl.publications.map(function(publication){
				return publication.id;
			}).indexOf(data.id);
			ctrl.publications[position] = data;
		});
		var deleteListener = $rootScope.$on('PublicationCtrl.destroy', function (event, data) {
			var position = ctrl.publications.map(function(publication){
				return publication.id;
			}).indexOf(data.object.id);
			ctrl.publications.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('PublisherCtrl', PublisherCtrl)
	PublisherCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","PublisherService","$controller"];
	function PublisherCtrl($rootScope,$scope, $http, $filter, $uibModal, PublisherService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'description','title':'Description'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'description','title':'Description'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.publishers			= [];
		ctrl.publisher			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Publishers
		ctrl.getPublishers = function(){
			PublisherService.getAllPublishers(ctrl.searchDB)
			.then(function(res){
				ctrl.publishers = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.publisherCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPublishers: ", err); 
			});
		}

		// get all Publishers for a specific parent
		ctrl.getPublishersModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			PublisherService.getAllPublishersByParent(parentId,parentType)
			.then(function(res){
				ctrl.publishers = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPublishers: ", err); 
			});
		}

		// get a specific Publisher
		ctrl.getPublisher = function(publisherId){
			PublisherService.getPublisher(publisherId)
			.then(function(res){
				ctrl.publisher = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPublishers: ", err); 
			});
		}

		// delete a specific Publisher
		ctrl.deletePublisher= function (publisher){
			if(confirm('Are you sure you want to delete this publisher?')){
				PublisherService.deletePublisher(publisher.uid)
				.then(function(res){
					var position = ctrl.publishers.map(function(publisher){
						return publisher.id;
					}).indexOf(publisher.id);
					ctrl.publishers.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}

		// Search all Publishers
		ctrl.searchPublishers = function(){
			PublisherService.getAllPublishers(ctrl.searchDB)
			.then(function(res){
				ctrl.publishers = res.data;
				ctrl.publisherCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchPublishers: ", err); 
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('PublisherCtrl.create', function (event, data) {
			ctrl.publishers.push(data.payload);
		});
		var updateListener = $rootScope.$on('PublisherCtrl.update', function (event, data) {
			var position = ctrl.publishers.map(function(publisher){
				return publisher.id;
			}).indexOf(data.id);
			ctrl.publishers[position] = data;
		});
		var deleteListener = $rootScope.$on('PublisherCtrl.destroy', function (event, data) {
			var position = ctrl.publishers.map(function(publisher){
				return publisher.id;
			}).indexOf(data.object.id);
			ctrl.publishers.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('SocmedCtrl', SocmedCtrl)
	SocmedCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","SocmedService","$controller"];
	function SocmedCtrl($rootScope,$scope, $http, $filter, $uibModal, SocmedService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'platform','title':'Platform'},
			{'class':'col-md-2','field':'link','title':'Link'},
			{'class':'col-md-2','field':'other','title':'Other'},
			{'class':'col-md-2','field':'description','title':'Description'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'platform','title':'Platform'},
			{'class':'col-md-2','field':'link','title':'Link'},
			{'class':'col-md-2','field':'other','title':'Other'},
			{'class':'col-md-2','field':'description','title':'Description'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.socmeds			= [];
		ctrl.socmed			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Socmeds
		ctrl.getSocmeds = function(){
			SocmedService.getAllSocmeds(ctrl.searchDB)
			.then(function(res){
				ctrl.socmeds = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.socmedCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSocmeds: ", err); 
			});
		}

		// get all Socmeds for a specific parent
		ctrl.getSocmedsModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			SocmedService.getAllSocmedsByParent(parentId,parentType)
			.then(function(res){
				ctrl.socmeds = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSocmeds: ", err); 
			});
		}

		// get a specific Socmed
		ctrl.getSocmed = function(socmedId){
			SocmedService.getSocmed(socmedId)
			.then(function(res){
				ctrl.socmed = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSocmeds: ", err); 
			});
		}

		// delete a specific Socmed
		ctrl.deleteSocmed= function (socmed){
			if(confirm('Are you sure you want to delete this socmed?')){
				SocmedService.deleteSocmed(socmed.uid)
				.then(function(res){
					var position = ctrl.socmeds.map(function(socmed){
						return socmed.id;
					}).indexOf(socmed.id);
					ctrl.socmeds.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}

		// Search all Socmeds
		ctrl.searchSocmeds = function(){
			SocmedService.getAllSocmeds(ctrl.searchDB)
			.then(function(res){
				ctrl.socmeds = res.data;
				ctrl.socmedCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchSocmeds: ", err); 
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('SocmedCtrl.create', function (event, data) {
			ctrl.socmeds.push(data.payload);
		});
		var updateListener = $rootScope.$on('SocmedCtrl.update', function (event, data) {
			var position = ctrl.socmeds.map(function(socmed){
				return socmed.id;
			}).indexOf(data.id);
			ctrl.socmeds[position] = data;
		});
		var deleteListener = $rootScope.$on('SocmedCtrl.destroy', function (event, data) {
			var position = ctrl.socmeds.map(function(socmed){
				return socmed.id;
			}).indexOf(data.object.id);
			ctrl.socmeds.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('SpotCtrl', SpotCtrl)
	SpotCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","SpotService","$controller"];
	function SpotCtrl($rootScope,$scope, $http, $filter, $uibModal, SpotService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'class','title':'Class'},
			{'class':'col-md-2','field':'qty','title':'Qty'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-5','field':'class','title':'Class'},
			{'class':'col-md-5','field':'qty','title':'Qty'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.spots			= [];
		ctrl.spot			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Spots
		ctrl.getSpots = function(){
			SpotService.getAllSpots(ctrl.searchDB)
			.then(function(res){
				ctrl.spots = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.spotCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSpots: ", err);
			});
		}

		// get all Spots for a specific parent
		ctrl.getSpotsModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			SpotService.getAllSpotsByParent(parentId,parentType)
			.then(function(res){
				ctrl.spots = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSpots: ", err);
			});
		}

		// get a specific Spot
		ctrl.getSpot = function(spotId){
			SpotService.getSpot(spotId)
			.then(function(res){
				ctrl.spot = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSpots: ", err);
			});
		}

		// delete a specific Spot
		ctrl.deleteSpot= function (spot){
			if(confirm('Are you sure you want to delete this spot?')){
				SpotService.deleteSpot(spot.uid)
				.then(function(res){
					var position = ctrl.spots.map(function(spot){
						return spot.id;
					}).indexOf(spot.id);
					ctrl.spots.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Spots
		ctrl.searchSpots = function(){
			SpotService.getAllSpots(ctrl.searchDB)
			.then(function(res){
				ctrl.spots = res.data;
				ctrl.spotCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchSpots: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('SpotCtrl.create', function (event, data) {
			ctrl.spots.push(data.payload);
		});
		var updateListener = $rootScope.$on('SpotCtrl.update', function (event, data) {
			var position = ctrl.spots.map(function(spot){
				return spot.id;
			}).indexOf(data.id);
			ctrl.spots[position] = data;
		});
		var deleteListener = $rootScope.$on('SpotCtrl.destroy', function (event, data) {
			var position = ctrl.spots.map(function(spot){
				return spot.id;
			}).indexOf(data.object.id);
			ctrl.spots.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('StageCtrl', StageCtrl)
	StageCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","StageService","$controller"];
	function StageCtrl($rootScope,$scope, $http, $filter, $uibModal, StageService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'sequence','title':'Sequence'},
			{'class':'col-md-2','field':'waits_for','title':'Waits For'},
			{'class':'col-md-2','field':'due_on','title':'Due On'},
			{'class':'col-md-2','field':'completed_at','title':'Completed At'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'sequence','title':'Sequence'},
			{'class':'col-md-2','field':'waits_for','title':'Waits For'},
			{'class':'col-md-2','field':'due_on','title':'Due On'},
			{'class':'col-md-2','field':'completed_at','title':'Completed At'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.stages			= [];
		ctrl.stage			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Stages
		ctrl.getStages = function(){
			StageService.getAllStages(ctrl.searchDB)
			.then(function(res){
				ctrl.stages = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.stageCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getStages: ", err); 
			});
		}

		// get all Stages for a specific parent
		ctrl.getStagesModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			StageService.getAllStagesByParent(parentId,parentType)
			.then(function(res){
				ctrl.stages = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getStages: ", err); 
			});
		}

		// get a specific Stage
		ctrl.getStage = function(stageId){
			StageService.getStage(stageId)
			.then(function(res){
				ctrl.stage = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getStages: ", err); 
			});
		}

		// delete a specific Stage
		ctrl.deleteStage= function (stage){
			if(confirm('Are you sure you want to delete this stage?')){
				StageService.deleteStage(stage.uid)
				.then(function(res){
					var position = ctrl.stages.map(function(stage){
						return stage.id;
					}).indexOf(stage.id);
					ctrl.stages.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}

		// Search all Stages
		ctrl.searchStages = function(){
			StageService.getAllStages(ctrl.searchDB)
			.then(function(res){
				ctrl.stages = res.data;
				ctrl.stageCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchStages: ", err); 
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('StageCtrl.create', function (event, data) {
			ctrl.stages.push(data.payload);
		});
		var updateListener = $rootScope.$on('StageCtrl.update', function (event, data) {
			var position = ctrl.stages.map(function(stage){
				return stage.id;
			}).indexOf(data.id);
			ctrl.stages[position] = data;
		});
		var deleteListener = $rootScope.$on('StageCtrl.destroy', function (event, data) {
			var position = ctrl.stages.map(function(stage){
				return stage.id;
			}).indexOf(data.object.id);
			ctrl.stages.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('SubmissionCtrl', SubmissionCtrl)
	SubmissionCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","SubmissionService","$controller"];
	function SubmissionCtrl($rootScope,$scope, $http, $filter, $uibModal, SubmissionService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'title','title':'Title'},
			{'class':'col-md-2','field':'status','title':'Status'},
			{'class':'col-md-2','field':'type','title':'Type'},
			{'class':'col-md-2','field':'placement','title':'Placement'},
			{'class':'col-md-2','field':'spouse_1','title':'Spouse 1'},
			{'class':'col-md-2','field':'spouse_2','title':'Spouse 2'},
			{'class':'col-md-2','field':'cover','title':'Cover'},
			{'class':'col-md-2','field':'notes','title':'Notes'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'title','title':'Title'},
			{'class':'col-md-2','field':'status','title':'Status'},
			{'class':'col-md-2','field':'type','title':'Type'},
			{'class':'col-md-2','field':'placement','title':'Placement'},
			{'class':'col-md-2','field':'spouse_1','title':'Spouse 1'},
			{'class':'col-md-2','field':'spouse_2','title':'Spouse 2'},
			{'class':'col-md-2','field':'cover','title':'Cover'},
			{'class':'col-md-2','field':'notes','title':'Notes'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.submissions			= [];
		ctrl.submission			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Submissions
		ctrl.getSubmissions = function(){
			SubmissionService.getAllSubmissions(ctrl.searchDB)
			.then(function(res){
				ctrl.submissions = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.submissionCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSubmissions: ", err); 
			});
		}

		// get all Submissions for a specific parent
		ctrl.getSubmissionsModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			SubmissionService.getAllSubmissionsByParent(parentId,parentType)
			.then(function(res){
				ctrl.submissions = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSubmissions: ", err); 
			});
		}

		// get a specific Submission
		ctrl.getSubmission = function(submissionId){
			SubmissionService.getSubmission(submissionId)
			.then(function(res){
				ctrl.submission = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSubmissions: ", err); 
			});
		}

		// delete a specific Submission
		ctrl.deleteSubmission= function (submission){
			if(confirm('Are you sure you want to delete this submission?')){
				SubmissionService.deleteSubmission(submission.uid)
				.then(function(res){
					var position = ctrl.submissions.map(function(submission){
						return submission.id;
					}).indexOf(submission.id);
					ctrl.submissions.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}

		// Search all Submissions
		ctrl.searchSubmissions = function(){
			SubmissionService.getAllSubmissions(ctrl.searchDB)
			.then(function(res){
				ctrl.submissions = res.data;
				ctrl.submissionCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchSubmissions: ", err); 
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('SubmissionCtrl.create', function (event, data) {
			ctrl.submissions.push(data.payload);
		});
		var updateListener = $rootScope.$on('SubmissionCtrl.update', function (event, data) {
			var position = ctrl.submissions.map(function(submission){
				return submission.id;
			}).indexOf(data.id);
			ctrl.submissions[position] = data;
		});
		var deleteListener = $rootScope.$on('SubmissionCtrl.destroy', function (event, data) {
			var position = ctrl.submissions.map(function(submission){
				return submission.id;
			}).indexOf(data.object.id);
			ctrl.submissions.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TicketCtrl', TicketCtrl)
	TicketCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","TicketService","$controller"];
	function TicketCtrl($rootScope,$scope, $http, $filter, $uibModal, TicketService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'status','title':'Status'},
			{'class':'col-md-2','field':'type','title':'Type'},
			{'class':'col-md-2','field':'details','title':'Details'},
			{'class':'col-md-2','field':'data','title':'Data'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-4','field':'status','title':'Status'},
			{'class':'col-md-4','field':'type','title':'Type'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.tickets			= [];
		ctrl.ticket			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Tickets
		ctrl.getTickets = function(){
			TicketService.getAllTickets(ctrl.searchDB)
			.then(function(res){
				ctrl.tickets = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.ticketCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTickets: ", err);
			});
		}

		// get all Tickets for a specific parent
		ctrl.getTicketsModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			TicketService.getAllTicketsByParent(parentId,parentType)
			.then(function(res){
				ctrl.tickets = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTickets: ", err);
			});
		}

		// get a specific Ticket
		ctrl.getTicket = function(ticketId){
			TicketService.getTicket(ticketId)
			.then(function(res){
				ctrl.ticket = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTickets: ", err);
			});
		}

		// delete a specific Ticket
		ctrl.deleteTicket= function (ticket){
			if(confirm('Are you sure you want to delete this ticket?')){
				TicketService.deleteTicket(ticket.uid)
				.then(function(res){
					var position = ctrl.tickets.map(function(ticket){
						return ticket.id;
					}).indexOf(ticket.id);
					ctrl.tickets.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Tickets
		ctrl.searchTickets = function(){
			TicketService.getAllTickets(ctrl.searchDB)
			.then(function(res){
				ctrl.tickets = res.data;
				ctrl.ticketCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchTickets: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('TicketCtrl.create', function (event, data) {
			ctrl.tickets.push(data.payload);
		});
		var updateListener = $rootScope.$on('TicketCtrl.update', function (event, data) {
			var position = ctrl.tickets.map(function(ticket){
				return ticket.id;
			}).indexOf(data.id);
			ctrl.tickets[position] = data;
		});
		var deleteListener = $rootScope.$on('TicketCtrl.destroy', function (event, data) {
			var position = ctrl.tickets.map(function(ticket){
				return ticket.id;
			}).indexOf(data.object.id);
			ctrl.tickets.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TickleCtrl', TickleCtrl)
	TickleCtrl.$inject = [
		"$rootScope",
		"$scope",
		"TickleService",
		"$controller"
	];
	function TickleCtrl(
		$rootScope,
		$scope,
		TickleService,
		$controller
	){
		var ctrl = this;

		ctrl.global = $rootScope;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'type','title':'Type'},
			{'class':'col-md-2','field':'details','title':'Details'},
			{'class':'col-md-2','field':'due_on','title':'Due On'},
			{'class':'col-md-2','field':'completed_at','title':'Completed At'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'type','title':'Type'},
			{'class':'col-md-2','field':'details','title':'Details'},
			{'class':'col-md-2','field':'due_on','title':'Due On'},
			{'class':'col-md-2','field':'completed_at','title':'Completed At'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.tickles			= [];
		ctrl.tickle			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;
		ctrl.filterPhone = false;
		ctrl.filterEmail = false;
		ctrl.filterAddress = false;


		// get all Tickles
		ctrl.getTickles = function(){
			TickleService.getAllTickles(ctrl.searchDB)
			.then(function(res){
				ctrl.tickles = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.tickleCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTickles: ", err);
			});
		}

		// get all Tickles for a specific parent
		ctrl.getTicklesModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			TickleService.getAllTicklesByParent(parentId,parentType)
			.then(function(res){
				ctrl.tickles = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTickles: ", err);
			});
		}

		// get a specific Tickle
		ctrl.getTickle = function(tickleId){
			TickleService.getTickle(tickleId)
			.then(function(res){
				ctrl.tickle = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTickles: ", err);
			});
		}

		// complete a specific Tickle
		ctrl.completeTickle= function (tickle){
			if(confirm('Are you sure you want to complete this follow-up item?')){
				var data = {
					completed:true
				}
				TickleService.updateTickle(tickle.uid, data)
				.then(function(res){
					var position = ctrl.tickles.map(function(tickle){
						return tickle.id;
					}).indexOf(tickle.id);
					ctrl.tickles.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// delete a specific Tickle
		ctrl.deleteTickle= function (tickle){
			if(confirm('Are you sure you want to delete this tickle?')){
				TickleService.deleteTickle(tickle.uid)
				.then(function(res){
					var position = ctrl.tickles.map(function(tickle){
						return tickle.id;
					}).indexOf(tickle.id);
					ctrl.tickles.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Tickles
		ctrl.searchTickles = function(){
			TickleService.getAllTickles(ctrl.searchDB)
			.then(function(res){
				ctrl.tickles = res.data;
				ctrl.tickleCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchTickles: ", err);
			});
		}

		ctrl.emptyOrNullPhone = function(item){
			if(ctrl.filterPhone) {
				return !(item.contact_type != "Call")
			}
			return true;
		}

		ctrl.emptyOrNullAddress = function(item){
			if(ctrl.filterAddress) {
				return !(item.contact_type != "Visit")
			}
			return true;
		}

		ctrl.emptyOrNullEmail = function(item){
			if(ctrl.filterEmail) {
				return !(item.contact_type != "Email")
			}
			return true;
		}

		ctrl.getModelType = function(model){
			return model.split('\\').join('-');
		}

		ctrl.getContactableModelType = function(contactable){
			if(contactable.addressable_type != undefined) {
				return contactable.addressable_type.split('\\').join('-');
			}
			if(contactable.phoneable_type != undefined) {
				return contactable.phoneable_type.split('\\').join('-');
			}
			if(contactable.emailable_type != undefined) {
				return contactable.emailable_type.split('\\').join('-');
			}
		}

		// Events Listeners
		var createListener = $rootScope.$on('TickleCtrl.create', function (event, data) {
			ctrl.tickles.push(data.payload);
		});
		var updateListener = $rootScope.$on('TickleCtrl.update', function (event, data) {
			var position = ctrl.tickles.map(function(tickle){
				return tickle.id;
			}).indexOf(data.payload.id);
			ctrl.tickles[position] = data.payload;
		});
		var deleteListener = $rootScope.$on('TickleCtrl.destroy', function (event, data) {
			var position = ctrl.tickles.map(function(tickle){
				return tickle.id;
			}).indexOf(data.object.id);
			ctrl.tickles.splice(position,1);
		});

		var createPhoneListener = $rootScope.$on('TickleCtrl.createPhone', function (event, data) {
			var phone = data.payload;
			angular.forEach(ctrl.tickles, function (tickle, index) {
				if (tickle.contactable.parent_record.id == phone.parent_record.id) {
					tickle.contactable.parent_record.phones.push(phone);
				}
			});
		});
		var createAddressListener = $rootScope.$on('TickleCtrl.createAddress', function (event, data) {
			var address = data;
			angular.forEach(ctrl.tickles, function (tickle, index) {
				if (tickle.contactable.parent_record.id == address.parent_record.id) {
					tickle.contactable.parent_record.addresses.push(address);
				}
			});
		});
		var createEmailListener = $rootScope.$on('TickleCtrl.createEmail', function (event, data) {
			var email = data.payload;
			angular.forEach(ctrl.tickles, function (tickle, index) {
				if (tickle.contactable.parent_record.id == email.parent_record.id) {
					tickle.contactable.parent_record.emails.push(email);
				}
			});
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function () {
	'use strict';
	angular
	.module('myApp')
	.controller('UserCtrl', UserCtrl)
	UserCtrl.$inject = [
		"$rootScope",
		"$scope",
		"UserService",
		"RoleService",
		"$controller"
	];
	function UserCtrl(
		$rootScope,
		$scope,
		UserService,
		RoleService,
		$controller
	) {

		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', { $scope: $scope });

		angular.extend(this, base)

		//member data
		ctrl.roles = [],
			ctrl.columns = [
			{ 'class': 'col-sm-2', 'field': 'fullname', 'title': 'Name' },
			{ 'class': 'col-sm-2', 'field': 'email', 'title': 'Email' },
			{ 'class': 'col-sm-2', 'field': 'mobile_number', 'title': 'Mobile' },
			{ 'class': 'col-sm-4', 'field': 'registered_at', 'title': 'Registered Date' }
		];
		ctrl.modColumns = [
			{ 'class': 'col-sm-2', 'field': 'fullname', 'title': 'Name' },
			{ 'class': 'col-sm-2', 'field': 'email', 'title': 'Email' },
			{ 'class': 'col-sm-2', 'field': 'mobile_number', 'title': 'Mobile' },
			{ 'class': 'col-sm-4', 'field': 'created_at', 'title': 'Registered Date' }
		];
		ctrl.isTabulated = true;
		ctrl.showSearch = true;

		//methods
		ctrl.loadUsers = function () {
			ctrl.isLoaded = false;
			UserService.getAllUsers()
				.then(function (res) {
					ctrl.users = res.data;
					ctrl.userCount = res.count;
					ctrl.loadRoles();
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getDepartments: ", err);
				});
		}

		ctrl.loadUser = function (userId) {
			ctrl.userId = userId;
			UserService.getUser(ctrl.userId)
				.then(function (res) {
					ctrl.user = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getUser: ", err);
				});
		};

		// get all Users for a specific parent
		ctrl.getUsersModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			UserService.getAllUsersByParent(parentId,parentType)
			.then(function(res){
				ctrl.users = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getUsers: ", err);
			});
		}

		ctrl.loadRoles = function () {
			ctrl.isLoaded = false;
			RoleService.getAllRoles()
				.then(function (res) {
					ctrl.roles = res;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getDepartments: ", err);
				});
		}
		// Search all Donors
		ctrl.searchUsers = function () {
			UserService.getAllUsers(ctrl.searchDB)
				.then(function (res) {
					ctrl.users = res.data;
					ctrl.userCount = res.count;
					ctrl.searchQry.$ = '';
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM searchUsers: ", err);
				});
		}


		ctrl.deleteUser = function (user) {
			if (confirm('Are you certain you want to delete this user?')) {
				UserService.deleteUser(user.uid)
					.then(function (res) {
						var position = ctrl.users.map(function(user){
							return user.id;
						}).indexOf(res.id);
						ctrl.users.splice(position, 1);
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM deleteUser: ", err);
					});
			}
		}

		ctrl.changeUserPermission = function (role, user) {

			var permission = user.permissions[role.name] ? false : true;

			var post_data = {
				'user_id': user.id,
				'role_id': role.id,
			};
			// if this is true, we should be removing it
			if (!permission) {
				UserService.detachRole(post_data)
					.then(function (res) {
						user.permissions[role.name] = false;
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM attachRole: ", err);
						user.permissions[role.name] = true;
					});
			} else {
				UserService.attachRole(post_data)
					.then(function (res) {
						user.permissions[role.name] = true;
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM attachRole: ", err);
						user.permissions[role.name] = false;
					});
			}
		};

		// delete a specific Engagement
		ctrl.remove = function (user, parentId, parentType){
			if(confirm('Are you sure you want to remove this user?')){
				var data = {
					parentId:parentId,
					parentType:parentType,
					userId:user.id,
				};
				// return
				UserService.detachUserFromParent(data)
				.then(function(res){
					var position = ctrl.users.map(function(user){
						return user.id;
					}).indexOf(res.id);
					ctrl.users.splice(position, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}
		// Events Listener
		var createListener = $rootScope.$on('UserCtrl.create', function (event, data) {
			ctrl.users.push(data.payload);
		});
		var updateListener = $rootScope.$on('UserCtrl.update', function (event, data) {
			//do nothing
		});
		var deleteListener = $rootScope.$on('UserCtrl.delete', function (event, data) {
			var position = ctrl.users.map(function(user){
				return user.id;
			}).indexOf(data.id);
			ctrl.users.splice(position, 1);
		});
		var reloadListener = $rootScope.$on('UserCtrl.reload', function (event, data) {
			ctrl.loadUser(ctrl.userId);
		});

		$scope.$on('$destroy', function () {
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('WorkflowCtrl', WorkflowCtrl)
	WorkflowCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","WorkflowService","$controller"];
	function WorkflowCtrl($rootScope,$scope, $http, $filter, $uibModal, WorkflowService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'description','title':'Description'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'description','title':'Description'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.workflows			= [];
		ctrl.workflow			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Workflows
		ctrl.getWorkflows = function(){
			WorkflowService.getAllWorkflows(ctrl.searchDB)
			.then(function(res){
				ctrl.workflows = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.workflowCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getWorkflows: ", err); 
			});
		}

		// get all Workflows for a specific parent
		ctrl.getWorkflowsModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			WorkflowService.getAllWorkflowsByParent(parentId,parentType)
			.then(function(res){
				ctrl.workflows = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getWorkflows: ", err); 
			});
		}

		// get a specific Workflow
		ctrl.getWorkflow = function(workflowId){
			WorkflowService.getWorkflow(workflowId)
			.then(function(res){
				ctrl.workflow = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getWorkflows: ", err); 
			});
		}

		// delete a specific Workflow
		ctrl.deleteWorkflow= function (workflow){
			if(confirm('Are you sure you want to delete this workflow?')){
				WorkflowService.deleteWorkflow(workflow.uid)
				.then(function(res){
					var position = ctrl.workflows.map(function(workflow){
						return workflow.id;
					}).indexOf(workflow.id);
					ctrl.workflows.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}

		// Search all Workflows
		ctrl.searchWorkflows = function(){
			WorkflowService.getAllWorkflows(ctrl.searchDB)
			.then(function(res){
				ctrl.workflows = res.data;
				ctrl.workflowCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchWorkflows: ", err); 
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('WorkflowCtrl.create', function (event, data) {
			ctrl.workflows.push(data.payload);
		});
		var updateListener = $rootScope.$on('WorkflowCtrl.update', function (event, data) {
			var position = ctrl.workflows.map(function(workflow){
				return workflow.id;
			}).indexOf(data.id);
			ctrl.workflows[position] = data;
		});
		var deleteListener = $rootScope.$on('WorkflowCtrl.destroy', function (event, data) {
			var position = ctrl.workflows.map(function(workflow){
				return workflow.id;
			}).indexOf(data.object.id);
			ctrl.workflows.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
//# sourceMappingURL=controllers.js.map
